import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useRoute } from "vue-router/composables";
import { VignetteRoutes } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPageBrowseByLinks',
  setup(__props) {

const route = useRoute();
const routeName = computed<string>(() => route.name ?? "");

const isCongressionalSearchPage = computed(
  () => routeName.value === VignetteRoutes.SearchCongressional
);
const isFederalSearchPage = computed(
  () => routeName.value === VignetteRoutes.SearchFederal
);
const isStateSearchPage = computed(
  () => routeName.value === VignetteRoutes.SearchState
);
const isUniversalSearchPage = computed(
  () => routeName.value === VignetteRoutes.SearchUniversal
);

return { __sfc: true,route, routeName, isCongressionalSearchPage, isFederalSearchPage, isStateSearchPage, isUniversalSearchPage, VignetteRoutes }
}

})